import React from 'react';
import { Badge as BsBadge } from 'react-bootstrap5';
import { invertColor } from './helpers';

const Badge = props => {
  const { variant, color, children, className, pill, ...remainingProps } = props;
  const backgroundColor = color || props.style?.backgroundColor;

  const bsProps = { bg: variant || 'secondary' };

  props = { ...remainingProps, ...bsProps };

  // this is specifically for forcing the color by not passing a variant or bg.
  // Because of this, we don't use a Badge, because it will set the color with
  // !important, which cannot be overruled
  if (backgroundColor) {
    return (
      <span
        className={`badge ${pill ? 'rounded-pill' : ''} ${className}`}
        {...props}
        style={{ background: backgroundColor, color: invertColor(backgroundColor) }}
      >
        {children}
      </span>
    );
  }

  if (pill) {
    return (
      <BsBadge pill {...props} className={className}>
        {children}
      </BsBadge>
    );
  }

  return (
    <BsBadge {...props} className={className}>
      {children}
    </BsBadge>
  );
};

export default Badge;
